import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import {
  AiCoinBalance,
  AiCoinPack,
  AiCoinService,
  DEFAULT_AI_COIN_PACKS,
} from "src/app/Services/ai-coin.service";
import { AuthModalService } from "src/app/Services/auth-modal.service";
import {
  resolveCoinPurchaseReturnUrl,
  setCoinPurchaseReturnUrl,
} from "src/app/shared/utils/coin-purchase-return.util";

export interface AiCoinPurchaseDialogData {
  packs?: AiCoinPack[];
  balance?: AiCoinBalance | null;
  selectedPackId?: string;
  /** Where to send the user back after the purchase completes. */
  returnUrl?: string;
}

@Component({
  selector: "app-ai-coin-purchase-dialog",
  templateUrl: "./ai-coin-purchase-dialog.component.html",
  styleUrls: ["./ai-coin-purchase-dialog.component.scss"],
})
export class AiCoinPurchaseDialogComponent implements OnInit {
  coinPacks: AiCoinPack[] = [...DEFAULT_AI_COIN_PACKS];
  coinBalance: AiCoinBalance | null = null;
  selectedPackId = "try";
  isLoading = false;
  isLoggedIn = false;

  constructor(
    private dialogRef: MatDialogRef<AiCoinPurchaseDialogComponent>,
    private router: Router,
    private aiCoinService: AiCoinService,
    private authModalService: AuthModalService,
    @Inject(MAT_DIALOG_DATA) public data: AiCoinPurchaseDialogData
  ) {}

  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
    this.isLoggedIn = !!user;

    if (this.data?.packs?.length) {
      this.coinPacks = this.data.packs;
    }
    if (this.data?.balance) {
      this.coinBalance = this.data.balance;
    }
    if (this.data?.selectedPackId) {
      this.selectedPackId = this.data.selectedPackId;
    } else if (this.coinPacks.length > 1) {
      this.selectedPackId = this.coinPacks[1].id;
    }

    if (this.isLoggedIn && !this.coinBalance) {
      this.loadBalance();
    }
  }

  get selectedPack(): AiCoinPack {
    return (
      this.coinPacks.find((p) => p.id === this.selectedPackId) ||
      this.coinPacks[0]
    );
  }

  selectPack(packId: string): void {
    this.selectedPackId = packId;
  }

  close(): void {
    this.dialogRef.close();
  }

  purchase(): void {
    const packId = this.selectedPack?.id;
    if (!packId) {
      return;
    }

    const returnUrl = resolveCoinPurchaseReturnUrl(this.data?.returnUrl);
    const queryParams: { [key: string]: string } = { pack: packId };
    if (returnUrl) {
      queryParams.returnUrl = returnUrl;
      setCoinPurchaseReturnUrl(returnUrl);
    }

    if (!this.isLoggedIn) {
      this.dialogRef.close();
      const target = `/purchase-coins?${new URLSearchParams(
        queryParams
      ).toString()}`;
      this.authModalService.openModal("registration", target);
      return;
    }

    this.dialogRef.close({ purchased: true, packId });
    this.router.navigate(["/purchase-coins"], { queryParams });
  }

  private loadBalance(): void {
    this.isLoading = true;
    this.aiCoinService.getBalance().subscribe({
      next: (balance) => {
        this.coinBalance = balance;
        if (balance.packs?.length) {
          this.coinPacks = balance.packs;
        }
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }
}
